import { useLuxAddData } from '@moonpig/web-core-utils'

export const useLuxAddExperimentData = (
  additionalData: { name: string; value: string }[],
) => {
  useLuxAddData([...additionalData])
}
